module.exports = new __parcel__URL__("the-beatles-the-white-album.4b1047d1.jpg").toString();